"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var dom_ready_1 = require("../util/dom-ready");
//@ts-ignore
require("../theme.ts");
var Locate = /** @class */ (function (_super) {
    __extends(Locate, _super);
    function Locate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Locate.prototype.getScopeRoot = function (current) {
        while (true) {
            var p = current.parentNode;
            if (p) {
                current = p;
            }
            else {
                return current;
            }
        }
    };
    Locate.prototype.install = function () {
        var _this = this;
        dom_ready_1.domReady(function () {
            _this._setPosition();
        });
    };
    Locate.prototype._setPosition = function () {
        var root = this.getScopeRoot(this);
        var ele = root.querySelector(this.props.to);
        var rectA = this.shadowRoot.querySelector('.root').getBoundingClientRect();
        var rectB = ele.getBoundingClientRect();
        var tempLeft, tempTop;
        var st = document.documentElement.scrollTop || document.body.scrollTop;
        var sl = document.documentElement.scrollLeft || document.body.scrollLeft;
        var gutter = this.props.gutter;
        switch (this.props.direction) {
            case 'top-left':
                tempLeft = rectB.left;
                tempTop = (rectB.top - rectA.height - gutter);
                break;
            case 'top':
                console.log(11);
                tempLeft = rectB.left + (rectB.width / 2 - rectA.width / 2);
                tempTop = (rectB.top - rectA.height - gutter);
                break;
            case 'top-right':
                tempLeft = rectB.left + rectB.width - rectA.width;
                tempTop = (rectB.top - rectA.height - gutter);
                break;
            case 'left':
                tempLeft = rectB.left - rectA.width - gutter;
                tempTop = rectB.top + (rectB.height - rectA.height) / 2;
                break;
            case 'left-top':
                tempLeft = rectB.left - rectA.width - gutter;
                tempTop = rectB.top;
                break;
            case 'left-bottom':
                tempLeft = rectB.left - rectA.width - gutter;
                tempTop = rectB.top + (rectB.height - rectA.height);
                break;
            case 'bottom-left':
                tempLeft = rectB.left;
                tempTop = (rectB.top + rectB.height + gutter);
                break;
            case 'bottom':
                tempLeft = rectB.left + (rectB.width / 2 - rectA.width / 2);
                tempTop = (rectB.top + rectB.height + gutter);
                break;
            case 'bottom-right':
                tempLeft = rectB.left + rectB.width - rectA.width;
                tempTop = (rectB.top + rectB.height + gutter);
                break;
            case 'right':
                tempLeft = rectB.left + rectB.width + gutter;
                tempTop = rectB.top + (rectB.height - rectA.height) / 2;
                break;
            case 'right-top':
                tempLeft = rectB.left + rectB.width + gutter;
                tempTop = rectB.top;
                break;
            case 'right-bottom':
                tempLeft = rectB.left + rectB.width + gutter;
                tempTop = rectB.top + (rectB.height - rectA.height);
                break;
        }
        tempLeft = tempLeft + this.props.x + sl + 'px';
        tempTop = tempTop + this.props.y + st + 'px';
        this.style.left = tempLeft;
        this.style.top = tempTop;
    };
    Locate.prototype.updated = function () {
        this._setPosition();
    };
    Locate.prototype.render = function (props) {
        return (omi_1.h("div", { class: 'root', style: { display: props.show ? 'block' : 'none' } },
            omi_1.h("slot", null)));
    };
    Locate.css = css;
    Locate.defaultProps = {
        x: 0,
        y: 0,
        gutter: 4
    };
    Locate.propTypes = {};
    Locate = __decorate([
        omi_1.tag('m-locate')
    ], Locate);
    return Locate;
}(omi_1.WeElement));
exports.default = Locate;
